<template>
  <v-container>
    <div class="page optimization">
      <v-row class="optimization_head" align="center" justify="center">
        <v-col class="col-12" align="center">
          <h2
            class="pc"
            v-text="$t('optimization.original_lead_compound')"
          ></h2>
          <v-row class="optimization_top">
            <v-col class="col-sm-7 optimization_title">
              <h3>{{ $t("optimization.optimization_results") }}</h3>
              <strong v-if="timeEnd != undefined">{{ total }} compounds</strong>
              <strong v-else
                ><v-progress-circular
                  indeterminate
                  size="18"
                  width="3"
                  color="#bebebe"
                ></v-progress-circular
                ><span class="optimization_still"
                  >Still Calculating...</span
                ></strong
              >
            </v-col>
            <v-col class="text-right col-md-5">
              <v-btn
                class="btn_download1"
                depressed
                color="#F2F2F2"
                :to="`/download/${id}`"
                v-text="$t('optimization.download_to_email')"
              >
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="optimization_content">
        <v-col class="col-12">
          <div class="optimization_results">
            <div
              v-for="(item, i) in compounds"
              :key="i"
              :class="{
                optimization_results_col: true,
                optimization_results_col0: i == 0,
                active: open && i == 0,
                curr: curr == i,
              }"
              align="center"
            >
              <div class="optimization_result results">
                <h3 class="optimization_result_no mb">
                  Optimizated results {{ i }}.
                </h3>
                <v-btn
                  text
                  class="btn_collapse mb"
                  v-if="i == 0"
                  @click="collapse"
                >
                  <span
                    v-text="$t('optimization.original_lead_compound')"
                  ></span>
                  <v-icon v-show="open == true"
                    >mdi-chevron-down-circle-outline</v-icon
                  >
                  <v-icon v-show="open == false"
                    >mdi-chevron-up-circle-outline</v-icon
                  >
                </v-btn>
                <v-btn
                  text
                  class="btn_prev mb"
                  v-if="i != 0"
                  @click="prevComp"
                  :disabled="curr < 2"
                >
                  <v-icon size="80">mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                  text
                  class="btn_next mb"
                  v-if="i != 0"
                  @click="nextComp"
                  :disabled="curr > total - 1"
                >
                  <v-icon size="80">mdi-chevron-right</v-icon>
                </v-btn>
                <div class="drawer_frame">
                  <SmilesDrawer
                    :id="`preview${i}`"
                    :smiles="item"
                    :width="230"
                    :height="230"
                    class="drawer"
                    ref="element"
                  ></SmilesDrawer>
                </div>
                <div class="results-smiles d-flex align-center justify-center">
                  <div>{{ item }}</div>
                </div>
                <div class="results-similarity row">
                  <v-row
                    class="col-md-12"
                    v-for="ep in predictionTop"
                    :key="ep.endpoint"
                  >
                    <v-col cols="7">
                      <strong
                        :class="{ 'orange--text': ep.property == true }"
                        v-html="ep.endpointNameHtml"
                      ></strong>
                    </v-col>
                    <v-col cols="5">
                      <strong :class="{ 'orange--text': ep.property == true }"
                        >{{
                          i == 0
                            ? originResult[ep.endpoint] || {}
                            : (compoundsResult[item] || {})[ep.endpoint] ||
                              "- - -"
                        }}
                      </strong>
                    </v-col>
                  </v-row>
                </div>
                <v-row
                  v-for="(group, j) in prediction"
                  :key="j"
                  class="results-row"
                >
                  <v-col cols="7"
                    ><strong v-if="group[0].property != true && i == 0">{{
                      group[0].categoryName
                    }}</strong
                    ><strong
                      v-else-if="group[0].property != true && i != 0"
                      class="results-row-p"
                    >
                      &nbsp;</strong
                    ></v-col
                  >
                  <v-col cols="5" v-if="group[0].property != true"></v-col>

                  <v-col
                    cols="12"
                    v-for="(ep, k) in group"
                    :key="k"
                    :class="{ 'result-visible': ep.visible }"
                  >
                    <v-row v-if="ep.endpoint != property && (i == 0 || !show)">
                      <v-col cols="7"
                        >{{ ep.endpointName || "- - -" }}<br />({{
                          ep.unitName || "- - -"
                        }})</v-col
                      >
                      <v-col cols="5" v-if="i == 0"
                        ><b
                          v-if="
                            ep.visible == true &&
                            originResult[ep.endpoint] != undefined
                          "
                        >
                          {{ originResult[ep.endpoint] }}
                        </b>
                        <b v-else-if="ep.visible == true"
                          ><v-progress-circular
                            indeterminate
                            size="18"
                            width="3"
                            color="#bebebe"
                          ></v-progress-circular
                        ></b>
                        <b v-else> - - - </b></v-col
                      >
                      <v-col cols="5" v-else>
                        <b
                          v-if="
                            ep.visible == true &&
                            (compoundsResult[item] || {})[ep.endpoint] !=
                              undefined
                          "
                        >
                          {{ (compoundsResult[item] || {})[ep.endpoint] }}
                        </b>
                        <b v-else-if="ep.visible == true"
                          ><v-progress-circular
                            indeterminate
                            size="18"
                            width="3"
                            color="#bebebe"
                          ></v-progress-circular
                        ></b>
                        <b v-else> - - - </b></v-col
                      >
                    </v-row>
                    <v-row v-else class="optimization_load">
                      <v-col cols="12" style="height: 80px">
                        <v-fade-transition>
                          <v-skeleton-loader
                            v-if="i != 0"
                            v-show="waiting"
                            class="mx-auto"
                            max-width="300"
                            type="card-heading"
                          ></v-skeleton-loader>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-fade-transition>
                  <div
                    v-if="i != 0 && show && !waiting"
                    class="optimization_wait"
                  >
                    <v-btn
                      depressed
                      class="btn_view"
                      color="#D56A51"
                      @click="viewAll"
                    >
                      View ADMET/PK prediction
                    </v-btn>
                  </div>
                </v-fade-transition>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-fade-transition>
        <div class="calculating remind" v-show="visible">
          <v-row>
            <v-col cols="12" class="d-flex align-center justify-center">
              <div class="calculating_block">
                <v-card transition="slide-x-transition">
                  <v-card-text>
                    <div class="drawer_frame">
                      <SmilesDrawer
                        :id="`preview_load`"
                        :smiles="smiles"
                        :width="290"
                        :height="290"
                        class="drawer"
                        ref="element"
                      ></SmilesDrawer>
                    </div>
                    <div class="start_txt">
                      <div
                        class="start_smiles d-flex align-center justify-center"
                      >
                        <div>{{ smiles }}</div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
                <h2>Automatic Multi-Parameter Optimization</h2>
                <div class="remind_prop text-center">{{ propertyName }}</div>
                <div class="remind_text">
                  <p>
                    The DEMO version will take few minutes to optimize the
                    compound, please bear with us. Thank you!
                  </p>
                  <p>
                    <strong
                      >Remind: The URL of the next page is a permanent
                      link</strong
                    ><br />
                    During the period of the optimization, you can copy &amp;
                    share the link below or you can back to the optimization
                    result page whenever you want.
                  </p>
                </div>
                <div class="remind_url">
                  URL:<br />
                  <span class="remind_link">{{ optimizeUrl }}</span>
                  <input type="hidden" id="copy-link" :value="optimizeUrl" />
                  <v-btn text @click.stop.prevent="copyLink">
                    <v-icon size="20">mdi-content-copy</v-icon>
                  </v-btn>
                </div>
                <div class="remind_btn text-right">
                  <v-btn text color="primary" @click="closeRemind"
                    >Continue to optimization result page</v-btn
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-fade-transition>
    </div>
    <HintTag></HintTag>
    <LimitDialog ref="limit"></LimitDialog>
  </v-container>
</template>

<script>
import SmilesDrawer from "@/components/SmilesDrawer";
import Compounds from "@/components/Compounds";
import HintTag from "@/components/HintTag";
import LimitDialog from "@/components/LimitDialog";

export default {
  name: "Optimization",
  mixins: [Compounds],
  components: {
    SmilesDrawer,
    HintTag,
    LimitDialog
  },
  data() {
    return {
      open: true,
      curr: 1,
      show: true,
      visible: true,
      screening: null,
      optimizeUrl: null,
      waiting: false,
    };
  },
  watch: {
    total() {
      if (
        this.compoundsResultLength > (this.total + 1) * this.propertyTotal ||
        this.already
      )
        this.show = false;
    },
    visibleDialog(){
      if(this.visibleDialog == true){
        this.$refs.limit.open();
      }
    }
  },
  computed: {
    id() {
      return this.$route.params.id || "";
    },
    request() {
      return (this.screening || {}).request || {};
    },
    already() {
      return (this.request || {}).compounds != undefined;
    },
    result() {
      return Object.values((this.screening || {}).result || {}) || [];
    },
    smiles() {
      return (this.request || {}).smiles || "";
    },
    timeEnd() {
      return (this.request || {}).timeEnd;
    },
    visibleDialog(){
      return (this.visible == false && this.timeEnd != undefined && this.total == 0);
    },
    originResultMerged() {
      return Object.assign(
        {},
        (this.request || {}).result || {},
        ((this.request || {}).origin || {}).result || {}
      );
    },
    originResult() {
      return Object.values(this.originResultMerged || {}).reduce((p, c) => {
        p[c.endpoint] = this.getDisplayValue(c);
        return p;
      }, {});
    },
    property() {
      return (this.request || {}).property || "";
    },
    propertyTotal() {
      if (this.property == "logp_v_mutagenicity_op") return 2;
      else return 1;
    },
    propertyName() {
      return (this.endpointsList[this.property] || {}).endpointName;
    },
    compounds() {
      if (this.result.length < 1) return [this.smiles];
      else
        return Object.values(
          (this.result || []).reduce((p, c) => {
            if (p[this.smiles] == undefined) p[this.smiles] = this.smiles;
            p[c.smiles] = c.smiles;
            return p;
          }, {})
        );
    },
    compoundsResult() {
      return (this.result || []).reduce((p, c) => {
        if (p[c.smiles] == undefined) p[c.smiles] = {};
        p[c.smiles][c.endpoint] = this.getDisplayValue(c);
        return p;
      }, {});
    },
    compoundsResultLength() {
      let arr = Object.values(this.compoundsResult || {}).reduce((p, c) => {
        return p.concat(Object.values(c).length);
      }, []);
      return this.SumData(arr);
    },
    total() {
      return (this.compounds || []).length - 1;
    },
    endpoints() {
      return this.endpointsList || {};
    },
    predictionTop() {
      let this_ = this;
      return Object.values(
        Object.values(this.endpoints || {})
          .filter(
            (e) =>
              (e.endpoint == "logp" &&
                this.originResult["logp"] != undefined) ||
              (e.endpoint == "logp_v" &&
                this.originResult["logp_v"] != undefined) ||
              (e.endpoint == "mutagenicity" &&
                this.originResult["mutagenicity"] != undefined)
          )
          .filter((e) => this_.propertyCondition(e)) || {}
      );
    },
    prediction() {
      let this_ = this;
      return (
        Object.values(
          Object.values(this.endpoints || {})
            .filter((e) => this_.propertyCondition2(e))
            .reduce((p, c) => {
              if (c.category != undefined) {
                if (p[c.categoryId] == undefined) p[c.categoryId] = [];
                p[c.categoryId].push(c);
              }
              return p;
            }, {}) || {}
        ).sort((a, b) => {
          return a.categoryId - b.categoryId;
        }) || []
      );
    },
  },
  methods: {
    SumData(arr) {
      let sum = 0;
      for (let i = 0; i < arr.length; i++) {
        sum += arr[i];
      }
      return sum;
    },
    propertyCondition(e) {
      switch (this.property) {
        case "logp_op":
          return e.endpoint == "logp";
        case "logp_v_op":
          return e.endpoint == "logp_v";
        case "mutagenicity_op":
          return e.endpoint == "mutagenicity";
        case "logp_v_mutagenicity_op":
          return e.endpoint == "logp_v" || e.endpoint == "mutagenicity";
        default:
          return e.endpoint == "logp";
      }
    },
    propertyCondition2(e) {
      switch (this.property) {
        case "logp_op":
          return e.endpoint != "logp";
        case "logp_v_op":
          return e.endpoint != "logp_v";
        case "mutagenicity_op":
          return e.endpoint != "mutagenicity";
        case "logp_v_mutagenicity_op":
          return e.endpoint != "logp_v" && e.endpoint != "mutagenicity";
        default:
          return e.endpoint == "logp";
      }
    },
    collapse() {
      this.open = !this.open;
    },
    prevComp() {
      if (this.curr > 1) this.curr = this.curr - 1;
    },
    nextComp() {
      if (this.curr < this.total) this.curr = this.curr + 1;
    },
    viewAll() {
      if (this.waiting) return;
      this.waiting = true;
      let newComps = this.compounds.slice(1, this.compounds.length);
      let data = {
        id: this.$route.params.id,
        value: newComps,
      };
      const token = this.$root.userToken;
      this.$ajax(this.$root.api + "/viewAll", {
        method: "post",
        headers: {
          Authorization: token,
          "Content-Type": "application/json; charset=UTF-8",
        },
        data: data,
      })
        .then((res) => {
          if (res.data != false) {
            // let d = JSON.parse(JSON.stringify(res.data || [])) || {};
            // console.log(d);
            this.show = false;
          } else {
            this.$root.$somethingWrong(res.data);
          }
          this.waiting = false;
        })
        .catch((error) => {
          this.errorMsg = error;
        });
    },
    closeRemind() {
      this.visible = false;
    },
    copyLink() {
      let linkToCopy = document.querySelector("#copy-link");
      linkToCopy.setAttribute("type", "text");
      linkToCopy.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        alert("URL was copied " + msg);
      } catch (err) {
        alert("Oops, unable to copy");
      }
      linkToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
  },
  mounted() {
    let optimizeId = this.$route.params.id;
    if (this.screening == null && optimizeId != undefined) {
      this.$db.ref(`optimize/demo/${optimizeId}`).on("value", (snapshot) => {
        if (snapshot.exists()) {
          this.screening = snapshot.val() || {};
        }
      });
      this.optimizeUrl = window.location.href;
    }
  },
};
</script>
